import { Tooltip } from "@mui/material";
import FiberManualRecordIcon from "@mui/icons-material/FiberManualRecord";

export const Online = (
  <Tooltip title="Online" color="success" placement="left">
    <FiberManualRecordIcon fontSize="small" />
  </Tooltip>
);

export const Offline = (
  <Tooltip title="Offline" color="error" placement="left">
    <FiberManualRecordIcon fontSize="small" />
  </Tooltip>
);
